/* PhotoJewels checkout engine v3
   - Product page: native wizard steps (Details = verify + address, Pay = inline payment options)
   - Cart page: overlay sheet fallback
   - WhatsApp OTP verification before payment (30-day remembered sessions)
   - UPI app intents + Cashfree modal + COD, Shopify order via backend */
(function () {
  'use strict';
  var CFG = window.PJ_CHECKOUT || {};
  var state = { phone: '', email: '', token: '', cart: null, address: null, addrType: 'Home', busy: false };
  var wizard = null;   // .pj-flow container on product pages
  var overlay = null;  // [data-pjck] sheet (cart page)

  document.addEventListener('DOMContentLoaded', function () {
    wizard = document.querySelector('[data-flow]');
    overlay = document.querySelector('[data-pjck]');
    restoreSession();
  });

  function scope() {
    if (overlay && !overlay.hidden) return overlay;
    return wizard || overlay || document;
  }
  function $(sel) { return scope().querySelector(sel); }

  function api(path, body) {
    var base = (CFG.api || '').replace(/\/+$/, '');
    if (!/^https?:\/\//.test(base)) {
      return Promise.reject(new Error('Checkout backend URL is missing in Theme settings \u2192 Checkout (custom)'));
    }
    var ctrl = new AbortController();
    var timer = setTimeout(function () { ctrl.abort(); }, 15000);
    return fetch(base + path, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body || {}),
      signal: ctrl.signal
    }).then(function (r) {
      return r.json().catch(function () {
        throw new Error('Server replied with an unexpected response (' + r.status + ')');
      }).then(function (j) {
        if (!r.ok || j.error) throw new Error(j.error || 'Something went wrong (' + r.status + ')');
        return j;
      });
    }).catch(function (ex) {
      if (ex.name === 'AbortError') throw new Error('Could not reach the checkout server \u2014 try again');
      throw ex;
    }).finally(function () { clearTimeout(timer); });
  }
  /* ---------------- tracking (browser side; server mirrors Purchase via CAPI with same event id) ---------------- */
  var T = window.PJ_TRACK || {};
  function cookie(name) { var m = document.cookie.match(new RegExp('(^|;\\s*)' + name + '=([^;]+)')); return m ? decodeURIComponent(m[2]) : ''; }
  function uuid() { return 'pj-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 10); }
  function utm() { try { return JSON.parse(localStorage.getItem('pj_utm') || 'null'); } catch (e) { return null; } }
  function cartItems() {
    if (!state.cart || !state.cart.items) return [];
    return state.cart.items.map(function (it) {
      return { item_id: String(it.variant_id), item_name: it.product_title, price: it.final_price / 100, quantity: it.quantity };
    });
  }
  function cartValue() { return state.cart ? state.cart.total_price / 100 : 0; }
  function track(evt, data) {
    data = data || {};
    var items = cartItems();
    var value = data.value != null ? data.value : cartValue();
    var ids = items.map(function (i) { return i.item_id; });
    try {
      if (window.oaiq && T.oai) {
        var oaiName = { begin_checkout: 'checkout_started', purchase: 'order_created', add_to_cart: 'items_added' }[evt];
        if (oaiName) oaiq('measure', oaiName, {
          type: 'contents',
          amount: Math.round(value * 100),
          currency: T.currency || 'INR',
          contents: items.map(function (i) { return { id: String(i.item_id), name: i.item_name, content_type: 'product', quantity: i.quantity || 1 }; })
        }, data.eventId ? { event_id: data.eventId } : undefined);
      }
      if (window.fbq && T.fb) {
        var fbName = { begin_checkout: 'InitiateCheckout', add_payment_info: 'AddPaymentInfo', purchase: 'Purchase', add_to_cart: 'AddToCart' }[evt];
        if (fbName) fbq('track', fbName, { value: value, currency: T.currency || 'INR', content_ids: ids, content_type: 'product', num_items: items.length }, data.eventId ? { eventID: data.eventId } : undefined);
      }
      if (window.gtag) {
        if (T.ga4) gtag('event', evt, Object.assign({ currency: T.currency || 'INR', value: value, items: items }, data.transactionId ? { transaction_id: data.transactionId } : {}));
        if (evt === 'purchase' && T.gads && T.gadsLabel) {
          gtag('event', 'conversion', { send_to: T.gads + '/' + T.gadsLabel, value: value, currency: T.currency || 'INR', transaction_id: data.transactionId || '' });
        }
        if (evt === 'purchase' && T.gads && state.phone) {
          gtag('set', 'user_data', { phone_number: '+' + state.phone, email: state.email || undefined, address: state.address ? { first_name: state.address.name, postal_code: state.address.zip, city: state.address.city, region: state.address.province, country: 'IN' } : undefined });
        }
      }
      if (window.clarity && evt === 'purchase') clarity('event', 'purchase');
    } catch (e) {}
  }

  /* online-payment discount display: derive from whatever the live total shows */
  function parseRupees(txt) {
    var m = String(txt || '').match(/(\d[\d,]*)(\.\d+)?/); // first number, ignoring "Rs." etc.
    return m ? parseFloat(m[1].replace(/,/g, '') + (m[2] || '')) : null;
  }
  function fmtRupees(n) { return '\u20B9' + Math.round(n).toLocaleString('en-IN'); }
  function refreshOnlineTotal() {
    var off = Number(CFG.onlineDiscount) || 0;
    document.querySelectorAll('[data-pjck-step="pay"], [data-step-panel="4"]').forEach(function (root) {
      var full = null;
      var inOverlay = !!root.closest('[data-pjck]');
      if (!inOverlay && typeof window.__pjTotalCents === 'number') full = window.__pjTotalCents / 100; // exact, from the price engine
      else if (inOverlay && state.cart && typeof state.cart.total_price === 'number') full = state.cart.total_price / 100;
      else { var src = root.querySelector('[data-total-inline]') || root.querySelector('[data-pjck-total]'); full = parseRupees(src && src.textContent); }
      if (full == null) return;
      var minFor = Number(CFG.onlineDiscountMin) || 0, pct = Number(CFG.onlineDiscountPct) || 0;
      var save = (off && full >= minFor) ? off : (full < minFor ? Math.round(full * pct) / 100 : 0);
      if (save >= full) save = 0;
      var net = Math.max(0, full - save);
      root.querySelectorAll('[data-pjck-save-amt]').forEach(function (el) { el.textContent = fmtRupees(save); });
      root.querySelectorAll('[data-pjck-online-total]').forEach(function (el) { el.textContent = fmtRupees(net); });
      root.querySelectorAll('[data-pjck-full-total]').forEach(function (el) { el.textContent = fmtRupees(full); });
      var giftMin = Number(CFG.freeGiftMin) || 0;
      var giftOk = !!CFG.freeGiftVariant && full >= giftMin;
      document.querySelectorAll('.pj-giftrow, .pjck__giftflag').forEach(function (el) { el.hidden = !giftOk; });
      root.querySelectorAll('.pjck__offerline').forEach(function (el) { el.hidden = !(save > 0); });
      root.querySelectorAll('.pjck__save').forEach(function (el) { el.hidden = !(save > 0); });
      var codFee = Number(CFG.codFee) || 0;
      root.querySelectorAll('[data-pjck-cod-total]').forEach(function (el) { el.textContent = fmtRupees(full + codFee) + (codFee > 0 ? ' (incl. \u20B9' + codFee + ' fee)' : ''); });
    });
  }
  (function () {
    var mo = new MutationObserver(refreshOnlineTotal);
    function arm() {
      document.querySelectorAll('[data-total-inline], [data-pjck-total]').forEach(function (el) { mo.observe(el, { childList: true, characterData: true, subtree: true }); });
      refreshOnlineTotal();
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', arm); else arm();
    document.addEventListener('click', function () { setTimeout(refreshOnlineTotal, 200); });
    window.addEventListener('pj:total', refreshOnlineTotal);
  })();

  function money(cents) { return '\u20B9' + (cents / 100).toLocaleString('en-IN'); }
  function busy(on) {
    state.busy = on;
    var el = $('[data-pjck-loading]');
    if (el) el.hidden = !on;
    document.documentElement.classList.toggle('pjck-busy', !!on);
    document.querySelectorAll('[data-pjck-pay-online], [data-pjck-pay-cod]').forEach(function (b) {
      b.classList.toggle('is-loading', !!on);
      if (on && !b.dataset.origLabel) {
        b.dataset.origLabel = b.innerHTML;
        b.innerHTML = '<span class="pjck__btn-title">' + (b.hasAttribute('data-pjck-pay-cod') ? 'Placing order\u2026' : 'Opening payment\u2026') + '</span>';
      } else if (!on && b.dataset.origLabel) {
        b.innerHTML = b.dataset.origLabel;
        delete b.dataset.origLabel;
      }
    });
  }
  function err(kind, msg) {
    var el = $('[data-pjck-err-' + kind + ']');
    if (el) el.textContent = msg || '';
  }

  /* ---------------- session ---------------- */
  function restoreSession() {
    var saved = null;
    try { saved = JSON.parse(localStorage.getItem('pj_session') || 'null'); } catch (e) {}
    if (!saved || !saved.t) return;
    api('/session/check', { token: saved.t }).then(function (j) {
      state.token = saved.t;
      state.phone = j.phone || saved.p || '';
      if (j.address) fillAddress(j.address);
      markVerified();
    }).catch(function () {
      try { localStorage.removeItem('pj_session'); } catch (e) {}
    });
  }
  function storeSession() {
    try { localStorage.setItem('pj_session', JSON.stringify({ t: state.token, p: state.phone })); } catch (e) {}
  }
  function clearSession() {
    state.token = ''; state.phone = '';
    try { localStorage.removeItem('pj_session'); } catch (e) {}
  }
  function checkCod() {
    if (!state.token) return;
    api('/cod/check', { token: state.token }).then(function (j) {
      var blocked = j && j.allowed === false;
      document.querySelectorAll('[data-pjck-paybar]').forEach(function (bar) {
        bar.classList.toggle('is-online-only', blocked);
        var cod = bar.querySelector('[data-pjck-pay-cod]');
        if (cod) cod.hidden = blocked;
      });
      document.querySelectorAll('[data-pjck-codblocked]').forEach(function (el) {
        el.hidden = !blocked;
        if (blocked) el.textContent = j.reason || 'COD not available for this order \u2014 please pay online.';
      });
      document.querySelectorAll('.pjck__codnote').forEach(function (el) { el.hidden = blocked; }); // no "COD available" while it's blocked
    }).catch(function () {});
  }
  function markVerified() {
    checkCod();
    scope().querySelectorAll('[data-pjck-verifiedchip]').forEach(function (c) { c.hidden = false; });
    var ph = $('[data-pjck-phone]');
    if (ph && state.phone && !ph.value) ph.value = String(state.phone).replace(/^91/, '');
  }
  function unmarkVerified() {
    scope().querySelectorAll('[data-pjck-verifiedchip]').forEach(function (c) { c.hidden = true; });
  }
  function showVerifyBlock(btn) {
    pendingContinue = btn || null;
    scope().querySelectorAll('[data-pjck-formcard]').forEach(function (c) { c.hidden = true; });
    if (btn) btn.hidden = true;
    var vb = $('[data-pjck-verifyblock]');
    if (vb) vb.hidden = false;
    var e1 = $('[data-pjck-phone-echo]');
    if (e1) e1.textContent = '+91 ' + String(state.phone).replace(/^91/, '');
    var rs = $('[data-pjck-resend]');
    if (rs) { rs.disabled = true; setTimeout(function () { rs.disabled = false; }, 30000); }
    var otp = $('[data-pjck-otp]');
    if (otp) { otp.value = ''; otp.focus(); }
  }
  function hideVerifyBlock() {
    scope().querySelectorAll('[data-pjck-formcard]').forEach(function (c) { c.hidden = false; });
    var vb = $('[data-pjck-verifyblock]');
    if (vb) vb.hidden = true;
    if (pendingContinue) pendingContinue.hidden = false;
  }

    /* ---------------- address helpers ---------------- */
  function readAddress() {
    var f = {};
    scope().querySelectorAll('[data-af]').forEach(function (i) { f[i.dataset.af] = (i.value || '').trim(); });
    return {
      name: f.name || '',
      address1: f.address1 || '',
      address2: f.landmark ? 'Landmark: ' + f.landmark : '',
      city: f.city || '',
      province: f.province || '',
      zip: f.zip || ''
    };
  }
  function fillAddress(a) {
    if (!a) return;
    var map = { name: a.name, address1: a.address1, landmark: String(a.address2 || '').replace(/^Landmark:\s*/i, ''), city: a.city, province: a.province, zip: a.zip };
    Object.keys(map).forEach(function (k) {
      var el = scope().querySelector('[data-af="' + k + '"]');
      if (el && map[k] && !el.value) el.value = map[k];
    });
  }

  function show(step) {
    if (!overlay) return;
    overlay.querySelectorAll('[data-pjck-step]').forEach(function (s) {
      s.hidden = s.dataset.pjckStep !== step;
    });
    overlay.querySelectorAll('[data-bar]').forEach(function (b) {
      b.classList.toggle('is-active', b.dataset.bar === step);
      b.classList.toggle('is-done', step === 'pay' && b.dataset.bar === 'details');
    });
  }

  /* ---------------- overlay open (cart page) ---------------- */
  window.PJOpenCheckout = function () {
    if (!overlay) return;
    overlay.hidden = false;
    document.body.style.overflow = 'hidden';
    show('details');
    loadCartSummary();
    if (state.token) markVerified();
  };
  function closeOverlay() {
    if (!overlay) return;
    overlay.hidden = true;
    document.body.style.overflow = '';
  }
  function loadCartSummary() {
    setTimeout(refreshOnlineTotal, 50);
    return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      state.cart = cart;
      var box = $('[data-pjck-summary]');
      if (box) {
        if (!cart.items.length) { box.innerHTML = '<div class="pjck__empty">Your bag is empty.</div>'; }
        else {
          box.innerHTML = cart.items.map(function (it) {
            return '<div class="pjck__item"><img src="' + (it.image || '') + '&width=80" alt=""><span class="pjck__itname">' + it.product_title +
                   (it.quantity > 1 ? ' \u00d7 ' + it.quantity : '') + '</span><span>' + money(it.final_line_price) + '</span></div>';
          }).join('') + '<div class="pjck__total"><span>Total</span><span>' + money(cart.total_price) + '</span></div>';
        }
      }
      return cart;
    });
  }

  /* ---------------- clicks ---------------- */
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-pj-checkout]')) { e.preventDefault(); window.PJOpenCheckout(); return; }
    if (overlay && !overlay.hidden && (e.target.closest('[data-pjck-close]') || e.target === overlay)) { closeOverlay(); return; }

    if (e.target.closest('[data-pjck-resend]')) {
      var rs2 = e.target.closest('[data-pjck-resend]');
      busy(true);
      api('/otp/send', { phone: state.phone }).catch(function () {}).finally(function () { busy(false); });
      rs2.disabled = true;
      setTimeout(function () { rs2.disabled = false; }, 30000);
      return;
    }
    if (e.target.closest('[data-pjck-logout]')) { clearSession(); unmarkVerified(); return; }
    if (e.target.closest('[data-pjck-editdetails]')) { hideVerifyBlock(); var pf = $('[data-pjck-phone]'); if (pf) pf.focus(); return; }

    /* payment method segment */
    var seg = e.target.closest('[data-pjck-method]');
    if (seg) {
      var method = seg.dataset.pjckMethod;
      scope().querySelectorAll('[data-pjck-method]').forEach(function (b) {
        b.classList.toggle('is-active', b === seg);
      });
      var ob = scope().querySelector('[data-pjck-onlinebox]');
      var cb = scope().querySelector('[data-pjck-codbox2]');
      if (ob) ob.hidden = method !== 'online';
      if (cb) cb.hidden = method !== 'cod';
      err('pay');
      return;
    }

    /* UPI apps */
    var upiBtn = e.target.closest('[data-pjck-upi]');
    if (upiBtn) { pay('upi', upiBtn.dataset.pjckUpi); return; }
    if (e.target.closest('[data-pjck-paywait-cancel]')) { stopPolling(); return; }
    if (e.target.closest('[data-pjck-pay-online]')) { pay('modal'); return; }
    if (e.target.closest('[data-pjck-pay-cod]')) { pay('cod'); return; }
  });

  function captureLead() {
    try {
      var items = [];
      var form = document.querySelector('[data-product-form]');
      if (form) {
        var idEl = form.querySelector('input[name="id"]');
        var qEl = form.querySelector('[data-order-qty-input]');
        var titleEl = document.querySelector('.pj-pdp__title');
        if (idEl) items.push({ variant_id: idEl.value, quantity: (qEl && parseInt(qEl.value, 10)) || 1, title: titleEl ? titleEl.textContent.trim() : '' });
      } else if (state.cart && state.cart.items) {
        items = state.cart.items.map(function (it) { return { variant_id: it.variant_id, quantity: it.quantity, title: it.product_title }; });
      }
      var base = (CFG.api || '').replace(/\/+$/, '');
      fetch(base + '/lead', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ phone: state.phone, email: state.email || '', address: state.address, items: items }),
        keepalive: true
      }).catch(function () {});
    } catch (e) {}
  }

  /* Details -> Pay: validate everything, then verify on WhatsApp (only if not already verified) */
  var pendingContinue = null;
  document.addEventListener('click', function (e) {
    var next = e.target.closest('[data-flow-next][data-for-step="3"], [data-pjck-to-pay]');
    if (!next) return;
    var isOverlay = !!e.target.closest('[data-pjck]');

    var phEl = $('[data-pjck-phone]');
    var p = (phEl && phEl.value || '').replace(/\D/g, '');
    if (p.length !== 10) {
      e.preventDefault(); e.stopPropagation();
      err('address', 'Enter your 10-digit WhatsApp number');
      if (phEl) phEl.focus();
      return;
    }
    var a = readAddress();
    if (!a.name || !a.address1 || a.zip.length !== 6 || !a.city || !a.province) {
      e.preventDefault(); e.stopPropagation();
      err('address', 'Please fill name, full address, pincode, city and state');
      return;
    }
    var emailEl = $('[data-pjck-email]');
    var email = (emailEl && emailEl.value || '').trim();
    if (email && !/^\S+@\S+\.\S+$/.test(email)) {
      e.preventDefault(); e.stopPropagation();
      err('address', 'That email doesn\u2019t look right');
      return;
    }
    err('address');
    state.email = email;
    state.address = a;
    var samePhone = state.token && state.phone === '91' + p;
    if (state.token && state.phone !== '91' + p) { clearSession(); unmarkVerified(); samePhone = false; }
    state.phone = '91' + p;
    captureLead(); /* every valid Continue is a recoverable lead — until an order is actually placed/paid */
    startEarlyDraft(); /* draft order in Shopify from this moment; completed at payment, stays open if abandoned */
    track('begin_checkout');

    try { loadCashfree(); } catch (ex) {}
    if (samePhone) {
      /* already verified on this number — continue straight to payment */
      if (isOverlay) { e.preventDefault(); e.stopPropagation(); show('pay'); }
      return; /* wizard: let app.js advance */
    }

    /* needs WhatsApp verification first */
    e.preventDefault(); e.stopPropagation();
    err('contact'); busy(true);
    if (!next.dataset.origLabel) { next.dataset.origLabel = next.innerHTML; next.innerHTML = 'Sending OTP on WhatsApp\u2026'; }
    next.classList.add('is-loading');
    api('/otp/send', { phone: state.phone })
      .then(function () { showVerifyBlock(next); })
      .catch(function (ex) { err('address', ex.message); })
      .finally(function () {
        busy(false);
        next.classList.remove('is-loading');
        if (next.dataset.origLabel) { next.innerHTML = next.dataset.origLabel; delete next.dataset.origLabel; }
      });
  }, true);

  /* OTP auto-verify + pincode autofill */
  document.addEventListener('input', function (e) {
    var otp = e.target.closest('[data-pjck-otp]');
    if (otp) {
      var v = otp.value.replace(/\D/g, '');
      if (v !== otp.value) otp.value = v;
      if (v.length === 6 && !state.busy) verifyOtp(v);
      return;
    }
    var zipEl = e.target.closest('[data-af="zip"]');
    if (!zipEl) return;
    var zip = zipEl.value.replace(/\D/g, '');
    if (zip.length === 6) {
      fetch('https://api.postalpincode.in/pincode/' + zip)
        .then(function (r) { return r.json(); })
        .then(function (j) {
          var po = j && j[0] && j[0].PostOffice && j[0].PostOffice[0];
          if (po) {
            var c = scope().querySelector('[data-af="city"]');
            var p = scope().querySelector('[data-af="province"]');
            if (c && !c.value) c.value = po.District;
            if (p) p.value = po.State;
          }
        }).catch(function () {});
    }
  });

  function verifyOtp(code) {
    err('contact'); busy(true);
    api('/otp/verify', { phone: state.phone, code: code })
      .then(function (j) {
        state.token = j.token;
        storeSession();
        markVerified();
        hideVerifyBlock();
        var btn = pendingContinue;
        pendingContinue = null;
        if (btn) btn.click(); /* re-run continue — now verified, advances to payment */
      })
      .catch(function (ex) { err('contact', ex.message); })
      .finally(function () { busy(false); });
  }

  /* ---------------- payment ---------------- */
  var order = null; // { order_id, payment_session_id, links }
  var pollTimer = null, pollUntil = 0;

  function stopPolling() {
    if (pollTimer) clearTimeout(pollTimer);
    pollTimer = null;
    var w = $('[data-pjck-paywait]');
    if (w) w.hidden = true;
    var r = $('[data-pjck-upirow]');
    if (r) r.style.opacity = '';
  }
  function pollLoop(orderId) {
    if (Date.now() > pollUntil) {
      stopPolling();
      err('pay', 'Payment not confirmed yet \u2014 if money was deducted, you\u2019ll get a WhatsApp confirmation shortly.');
      return;
    }
    api('/checkout/status', { order_id: orderId })
      .then(function (j) {
        if (j.paid) { stopPolling(); return finish('Payment received!', j.status_url, j.order_name); }
        pollTimer = setTimeout(function () { pollLoop(orderId); }, 3000);
      })
      .catch(function () { pollTimer = setTimeout(function () { pollLoop(orderId); }, 4000); });
  }

  function cartSig() {
    try {
      var form = document.querySelector('[data-product-form]');
      var fd = form ? new URLSearchParams(new FormData(form)).toString() : 'cartpage';
      var addons = Array.prototype.map.call(document.querySelectorAll('[data-addon]:checked'), function (a) { return a.value; }).sort().join(',');
      return fd + '|' + addons;
    } catch (e) { return String(Date.now()); }
  }
  var prewarm = { sig: null, promise: null };
  function buildAndLoadCart() {
    var sig = cartSig();
    if (prewarm.promise && prewarm.sig === sig) return prewarm.promise; // already built in the background
    var build = window.PJBuildCart ? window.PJBuildCart() : Promise.resolve(null);
    prewarm.sig = sig;
    prewarm.promise = build.then(loadCartSummary);
    return prewarm.promise;
  }
  var prewarmTimer = null;
  function schedulePrewarm() {
    clearTimeout(prewarmTimer);
    prewarmTimer = setTimeout(function () {
      if (state.busy) return;
      var panel = document.querySelector('[data-step-panel="4"].is-active');
      if (!panel && !document.querySelector('[data-pjck]:not([hidden])')) return; // only near payment
      prewarm.sig = null; // force rebuild with the latest selections
      buildAndLoadCart().catch(function () { prewarm.promise = null; });
      order = null; // selections changed — any previously created payment order is stale
    }, 350);
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-flow-next][data-for-step="3"], [data-addon], [data-order-qty-change], [data-pjck-to-pay]')) schedulePrewarm();
  });
  function startEarlyDraft() {
    /* wait for the prewarmed cart (photo rides along), then create/refresh the draft */
    var tries = 0;
    (function attempt() {
      if (!(state.cart && state.cart.items && state.cart.items.length)) {
        if (++tries > 20) return; /* ~10s cap, then give up silently */
        return setTimeout(attempt, 500);
      }
      var payload = {
        phone: state.phone, email: state.email || '', address: state.address,
        cart: cartPayload(), draft_id: state.earlyDraft || null,
        tracking: { utm: utm() }
      };
      if (window.__pjPhotoLater) payload.photo_later = true;
      var altEl = document.querySelector('[data-pj-altphone]');
      var alt = altEl && altEl.value.replace(/\D/g, '');
      if (alt && alt.length === 10) payload.address.alt_phone = alt;
      api('/draft/start', payload).then(function (j) {
        if (j && j.draft_id) state.earlyDraft = j.draft_id;
      }).catch(function () {});
    })();
  }
  function cartPayload() {
    return state.cart.items.map(function (it) {
      return { variant_id: it.variant_id, quantity: it.quantity, properties: it.properties || {} };
    });
  }
  function ensureAddress() {
    if (state.address) return true;
    var a = readAddress();
    if (a.name && a.address1 && a.zip.length === 6 && a.city && a.province) { state.address = a; return true; }
    err('pay', 'Please complete your details first');
    return false;
  }
  function createOrder(method) {
    if (method === 'online' && order) {
      return Promise.resolve(order);
    }
    return buildAndLoadCart().then(function () {
      if (!state.cart || !state.cart.items.length) throw new Error('Your bag is empty');
      var addr = Object.assign({}, state.address);
      if (state.addrType) addr.address2 = ((addr.address2 || '') + ' (' + state.addrType + ')').trim();
      var payload = {
        token: state.token, phone: state.phone, email: state.email || '',
        address: addr, method: method, cart: cartPayload(),
        tracking: { event_id: purchaseEventId, fbp: cookie('_fbp'), fbc: cookie('_fbc'), url: location.href, utm: utm() }
      };
      if (state.earlyDraft) payload.draft_id = state.earlyDraft;
      if (CFG.freeGiftVariant) payload.free_gift_variant = CFG.freeGiftVariant;
      var altEl = document.querySelector('[data-pj-altphone]');
      var alt = altEl && altEl.value.replace(/\D/g, '');
      if (alt && alt.length === 10) payload.address.alt_phone = alt;
      return api('/checkout/create', payload);
    }).then(function (j) {
      if (method === 'online') order = { order_id: j.order_id, payment_session_id: j.payment_session_id, links: null };
      return method === 'online' ? order : j;
    });
  }

  var purchaseEventId = null;
  function pay(kind, upiApp) {
    if (state.busy) return;
    if (!purchaseEventId) purchaseEventId = uuid();
    track('add_payment_info');
    if (!state.token) { err('pay', 'Please verify your WhatsApp number in the previous step'); return; }
    if (!ensureAddress()) return;
    err('pay'); busy(true);

    if (kind === 'cod') {
      createOrder('cod')
        .then(function (j) { return finish('COD confirmed \u2014 hidden-photo preview coming on WhatsApp before shipping.', j.status_url, j.order_name); })
        .catch(function (ex) { if (/on its way|pay online/i.test(ex.message)) checkCod(); throw ex; })
        .catch(function (ex) { err('pay', ex.message); })
        .finally(function () { busy(false); });
      return;
    }

    if (kind === 'upi') {
      createOrder('online')
        .then(function (o) {
          if (o.links) return o;
          return api('/checkout/upi-intent', { token: state.token, payment_session_id: o.payment_session_id })
            .then(function (u) { o.links = u.links; return o; });
        })
        .then(function (o) {
          var link = o.links[upiApp] || o.links['default'] || o.links.bhim;
          if (!link) throw new Error('That UPI app isn\u2019t available \u2014 try "Other UPI" or Cards below');
          var w = $('[data-pjck-paywait]');
          if (w) w.hidden = false;
          var r = $('[data-pjck-upirow]');
          if (r) r.style.opacity = '.45';
          pollUntil = Date.now() + 5 * 60 * 1000;
          pollLoop(o.order_id);
          window.location.href = link;
        })
        .catch(function (ex) {
          // UPI intent needs Cashfree S2S approval on production — until then, fall back to the modal (which shows UPI too)
          if (/not enabled|approved|UPI link/i.test(ex.message)) { busy(false); return pay('modal'); }
          err('pay', ex.message);
        })
        .finally(function () { busy(false); });
      return;
    }

    /* modal: cards / netbanking / QR */
    createOrder('online')
      .then(function (o) {
        return loadCashfree().then(function (cashfree) {
          return cashfree.checkout({ paymentSessionId: o.payment_session_id, redirectTarget: '_modal' }).then(function (res) {
            if (res && res.error) throw new Error(res.error.message || 'Payment was not completed');
            pollUntil = Date.now() + 2 * 60 * 1000;
            pollLoop(o.order_id);
          });
        });
      })
      .catch(function (ex) { err('pay', ex.message); })
      .finally(function () { busy(false); });
  }

  function finish(msg, statusUrl, orderName) {
    stopPolling();
    track('purchase', { eventId: purchaseEventId, transactionId: orderName || purchaseEventId });
    order = null;
    // show success instantly; clear the cart in the background; no auto-redirect
    var payBlock = scope().querySelector('[data-pjck-step="pay"]');
    if (payBlock) payBlock.hidden = true;
    var doneBlock = scope().querySelector('[data-pjck-step="done"]');
    if (doneBlock) {
      doneBlock.hidden = false;
      var m = doneBlock.querySelector('[data-pjck-done-msg]');
      if (m) m.textContent = msg;
      var link = doneBlock.querySelector('[data-pjck-done-link]');
      if (link) { if (statusUrl) { link.href = statusUrl; link.hidden = false; } else { link.hidden = true; } }
      doneBlock.scrollIntoView({ block: 'start' });
    }
    window.scrollTo(0, 0);
    fetch('/cart/clear.js', { method: 'POST' }).catch(function () {}).then(function () {
      document.dispatchEvent(new CustomEvent('pj:cart:changed'));
    });
    return Promise.resolve();
  }

  var cfPromise = null;
  function loadCashfree() {
    if (cfPromise) return cfPromise;
    cfPromise = new Promise(function (resolve, reject) {
      var s = document.createElement('script');
      s.src = 'https://sdk.cashfree.com/js/v3/cashfree.js';
      s.onload = function () {
        try { resolve(window.Cashfree({ mode: CFG.cashfreeMode === 'production' ? 'production' : 'sandbox' })); }
        catch (ex) { reject(ex); }
      };
      s.onerror = function () { reject(new Error('Could not load payment SDK')); };
      document.head.appendChild(s);
    });
    return cfPromise;
  }
})();
/* ---------- My Orders page (phone login, shared session) ---------- */
(function () {
  'use strict';
  var CFG = window.PJ_CHECKOUT || {};
  var box = document.querySelector('[data-pj-orders]');
  if (!box) return;
  var phone = '';

  function q(s) { return box.querySelector(s); }
  function call(path, body) {
    return fetch((CFG.api || '').replace(/\/+$/, '') + path, {
      method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body || {})
    }).then(function (r) {
      return r.json().then(function (j) {
        if (!r.ok || j.error) throw new Error(j.error || 'Something went wrong');
        return j;
      });
    });
  }
  function saved() {
    try { return JSON.parse(localStorage.getItem('pj_session') || 'null'); } catch (e) { return null; }
  }
  function showLogin() { q('[data-pjo-login]').hidden = false; q('[data-pjo-list]').hidden = true; }
  function showList(p) {
    q('[data-pjo-login]').hidden = true;
    q('[data-pjo-list]').hidden = false;
    q('[data-pjo-phone-echo]').textContent = '+91 ' + String(p).replace(/^91/, '');
  }
  function renderOrders(list) {
    var out = q('[data-pjo-orders]');
    if (!list.length) { out.innerHTML = '<div class="pjo-empty">No orders yet on this number. Your next memory awaits \u2728</div>'; return; }
    out.innerHTML = list.map(function (o) {
      var d = new Date(o.date);
      var date = d.toLocaleDateString('en-IN', { day: 'numeric', month: 'short', year: 'numeric' });
      return '<a class="pjo-card" href="' + (o.url || '#') + '" target="_blank" rel="noopener">' +
        '<div class="pjo-card__top"><b>' + o.name + '</b><span>' + date + '</span></div>' +
        '<div class="pjo-card__items">' + o.items.join(', ') + '</div>' +
        '<div class="pjo-card__bottom"><span class="pjo-badge">' + o.fulfillment.toLowerCase() + '</span>' +
        '<span class="pjo-badge pjo-badge--pay">' + o.paid.toLowerCase() + '</span>' +
        '<span class="pjo-card__total">\u20B9' + Number(o.total).toLocaleString('en-IN') + '</span></div></a>';
    }).join('');
  }
  function loadOrders(token) {
    call('/account/orders', { token: token })
      .then(function (j) { renderOrders(j.orders); })
      .catch(function () { showLogin(); });
  }

  var s = saved();
  if (s && s.t) {
    call('/session/check', { token: s.t })
      .then(function (j) { showList(j.phone); loadOrders(s.t); })
      .catch(function () { showLogin(); });
  } else { showLogin(); }

  box.addEventListener('click', function (e) {
    if (e.target.closest('[data-pjo-send]')) {
      var p = (q('[data-pjo-phone]').value || '').replace(/\D/g, '');
      if (p.length !== 10) { q('[data-pjo-err]').textContent = 'Enter your 10-digit WhatsApp number'; return; }
      q('[data-pjo-err]').textContent = '';
      phone = '91' + p;
      call('/otp/send', { phone: phone })
        .then(function () { q('[data-pjo-otpbox]').hidden = false; q('[data-pjo-otp]').focus(); })
        .catch(function (ex) { q('[data-pjo-err]').textContent = ex.message; });
    }
    if (e.target.closest('[data-pjo-verify]')) {
      var code = (q('[data-pjo-otp]').value || '').replace(/\D/g, '');
      call('/otp/verify', { phone: phone, code: code })
        .then(function (j) {
          try { localStorage.setItem('pj_session', JSON.stringify({ t: j.token, p: phone })); } catch (ex) {}
          showList(phone);
          loadOrders(j.token);
        })
        .catch(function (ex) { q('[data-pjo-err]').textContent = ex.message; });
    }
    if (e.target.closest('[data-pjo-logout]')) {
      try { localStorage.removeItem('pj_session'); } catch (ex) {}
      showLogin();
    }
  });
})();
